
import * as angular from "angular";
import * as moment from "moment";

import { VeriDate } from "@services/veriDate.service";

class TimeAgoController implements angular.IComponentController {

    date: Date | moment.Moment;
    timeAgo: string;
    intervalPromise: angular.IPromise<any>;

    static $inject = ["$interval", "veriDate"];

    constructor(
        private readonly $interval: angular.IIntervalService,
        private readonly veriDate: VeriDate) {
    }

    $onInit(): void {
        this.render();

        this.intervalPromise = this.$interval(() => { this.render(); }, 60 * 1000);
    }

    $onDestroy(): void {
        this.$interval.cancel(this.intervalPromise);
    }

    private render() {
        this.timeAgo = this.veriDate.formatDate(this.date, "timeago");
    }
}

export class TimeAgoComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            date: "<"
        };

        this.controller = TimeAgoController;
        this.template = "{{$ctrl.timeAgo}}";
    }
}
